const BECOME_MEMBER_URL =
  window.location.origin === "https://skademelding.naf.no"
    ? "https://www.nye.naf.no/bli-medlem"
    : "https://test.nye.naf.no/bli-medlem";
export default BECOME_MEMBER_URL;
